import { toast } from 'react-toastify';
import { SetUserLogout } from '../../helper/HelperAuth'

export default async (url, argument, byPassValidation) => {
    const response = await fetch(url,argument).then((response) => {
        if(!response.ok){
            if(response.status === 401){
                if(byPassValidation === undefined && !byPassValidation){
                    toast.error("You're Not Authorized!", toast.POSITION.TOP_RIGHT);
                    SetUserLogout()
                    window.location = 'login'
                }                
            }else if(response.status === 404){
                response.json().then(json => {
                    try {
                        toast.error(json.errors.title, toast.POSITION.TOP_RIGHT);
                    } catch (e) {
                        toast.error("File not found!", toast.POSITION.TOP_RIGHT);
                    }
                });
            }else{
                response.json().then(json => {
                    try {
                        if (json.errors) {
                            if (json.errors.details) {
                                toast.error(json.errors.details, toast.POSITION.TOP_RIGHT);
                            } else if (json.errors[0]) {
                                toast.error(json.errors[0].details, toast.POSITION.TOP_RIGHT);
                            } else {
                                toast.error("Something went wrong!", toast.POSITION.TOP_RIGHT);
                            }
                        } else if (json.error) {
                            toast.error(json.error, toast.POSITION.TOP_RIGHT);
                        } else {
                            toast.error("Something went wrong!", toast.POSITION.TOP_RIGHT);
                        }
                    } catch (e) {
                        toast.error("Something went wrong!", toast.POSITION.TOP_RIGHT);
                    }   
                });
            }
        }
        return response;
    }).catch((error) => {
        toast.error(error, toast.POSITION.TOP_RIGHT);
        return { "ok": false };
    });

    return response;
}